import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api_Url = process.env.NEXT_PUBLIC_API_URL || "https://api.itsonlyonestop.com";

export const createRoomThunk = createAsyncThunk(
    "create-room",
    async ({ data, token }) => {
        try {
            const response = await axios.post(`${api_Url}/api/chat/create/room`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        }
        catch (error) {
            console.log("error:", error)
        }
    });

export const getChatMembersListThunk = createAsyncThunk(
    "get-chat-member-list",
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${api_Url}/api/chat/member/list`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        }
        catch (error) {
            console.log("error:", error)
            return rejectWithValue(error?.response?.data || "Unknown error");
        }
    });

export const getChatListThunk = createAsyncThunk(
    "get-chat-list",
    async ({ token, data }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${api_Url}/api/chat/list`, {
                params: data,
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        }
        catch (error) {
            console.log("error:", error)
            return rejectWithValue(error?.response?.data || "Unknown error");
        }
    });

